import React, { useEffect } from 'react';
import styles from './TeamProfile.module.css';
import useStore from '../../../../hooks/useStore';

const TeamProfile = () => {
    const { 
        address,
        userStatus,
        formatAddress,
        fetchTeamUserPhase1Size
    } = useStore();

    useEffect(() => {
        if (address) {
            fetchTeamUserPhase1Size();
        }
    }, [address, fetchTeamUserPhase1Size]);

    if (!address) {
        return (
            <div className={styles.container}>
                <div className={styles.notConnected}>
                    Please connect wallet to view team data
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2>
                    My Team Stats
                    <span className={styles.badge}>PHASE 2</span>
                </h2>
                <div className={styles.address}>{formatAddress(address)}</div>
            </div>
            <div className={styles.summaryStats}>
                <div className={styles.statCard}>
                    <span className={styles.statValue}>{userStatus.referral_count}</span>
                    <span className={styles.statLabel}>Direct Referrals</span>
                </div>
                <div className={styles.statCard}>
                    <span className={styles.statValue}>
                        {(userStatus.referral_count || 0) + (userStatus.indirect_referral_count || 0) - (userStatus.phase_1_size || 0)}
                    </span>
                    <span className={styles.statLabel}>Team Size</span>
                </div>
            </div>
            <div className={styles.remark}>
                Phase 1 Size: <span className={styles.phase1Value}>{userStatus.phase_1_size ?? '-'}</span>
            </div>
        </div>
    );
};

export default TeamProfile;
